"use client";

type MobileLegalSectionNavProps = {
  sections: Array<{ id: string; title: string }>;
  activeIndex: number;
  numbered?: boolean;
};

export function MobileLegalSectionNav({ sections, activeIndex, numbered = true }: MobileLegalSectionNavProps) {
  const selected = sections[Math.min(Math.max(activeIndex, 0), sections.length - 1)]?.id ?? "";

  return (
    <div className="sticky top-3 z-30 mb-10 rounded-2xl border border-white/10 bg-[#09090b]/95 p-3 shadow-[0_12px_36px_rgba(0,0,0,0.35)] backdrop-blur-xl lg:hidden">
      <label htmlFor="mobile-legal-section" className="mb-2 block text-[11px] font-medium uppercase tracking-[0.14em] text-white/50">
        Jump to section
      </label>
      <select
        id="mobile-legal-section"
        value={selected}
        onChange={(event) => {
          const id = event.currentTarget.value;
          if (id) window.location.hash = id;
        }}
        className="min-h-11 w-full rounded-xl border border-white/10 bg-white/[0.05] px-3 text-[14px] text-white/90 outline-none focus-visible:ring-2 focus-visible:ring-white/70"
      >
        {sections.map((section, index) => (
          <option key={section.id} value={section.id} className="bg-[#09090b] text-white">
            {numbered ? `${String(index + 1).padStart(2, "0")} · ${section.title}` : section.title}
          </option>
        ))}
      </select>
    </div>
  );
}
